var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconYesActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.223,15.952l-3.269-3.512a.689.689,0,0,0-.52-.233h0a.661.661,0,0,0-.52.233L23.251,36.289,15,27.673a.7.7,0,0,0-1.04,0l-3.306,3.454a.8.8,0,0,0,0,1.106L21.06,43.1a3.235,3.235,0,0,0,2.173,1.106,3.4,3.4,0,0,0,2.155-1.067h.019L50.242,17.058A.857.857,0,0,0,50.223,15.952Z",
    transform: "translate(-10.434 -12.206)",
    fill: "#3E6BE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYesActive);
export default __webpack_public_path__ + "static/media/icon-yes-active.ae129c6a.svg";
export { ForwardRef as ReactComponent };